export default __webpack_public_path__ + "static/DAFAx-logo-footer-6e1e3bc6784d27a06e051e5831d05da7.png";